import axios from 'axios/lib/axios';

const base = '/api/v1/ga/';
const timeout = 30000;

const endpoints = {
  pageView: function (dp, plt = 0) {
    gtag('event', 'page_view', {
      page_title: dp,
      page_location: dp,
      page_language: currentLocale,
    });
  },
  event: function (ec, ea, el) {
    gtag('event', ec, {
      action: ea,
      label: el,
    });
  },
};

export default endpoints;
